import { SVGProps, Ref, forwardRef } from 'react';

export const RotateRightFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="m9.764 6 1.46-1.46c-1.536.008-2.727.042-3.69.171-1.262.17-1.996.49-2.533 1.026-.537.537-.856 1.271-1.026 2.533-.173 1.288-.175 2.984-.175 5.366H2v-.068c0-2.299 0-4.116.191-5.538.197-1.461.61-2.638 1.537-3.566s2.104-1.34 3.566-1.537c1.074-.144 2.373-.18 3.936-.188L9.764 1.273 11.036 0l3.637 3.636-3.637 3.637z"
            fill="currentColor"
        />
        <path
            d="M22 16.5c0-6.562-.937-7.5-7.5-7.5S7 9.938 7 16.5s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5"
            fill="currentColor"
        />
    </svg>
));
RotateRightFilledSize24Glyph.displayName = 'RotateRightFilledSize24Glyph';
